jQuery(document).ready(function($) {

    /*setInterval(function(){
        $('.gallery__list-thumbnails .gallery__thumbnail:first').appendTo('.gallery__list-thumbnails');
    }, 4000);*/
    /*$('.gallery__list-thumbnails').flickity({
      autoPlay: true,
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      contain: true
  });*/


    $('.gallery__thumbnail-overlay').click(function(e) {
        e.preventDefault();
        var $idThumb = $(this).attr('href');
        var $mainImg = $($idThumb);
        $('.gallery__main-img img').removeClass('is-selected');
        $mainImg.addClass('is-selected');
    });

})
